// extracted by mini-css-extract-plugin
export default {"contentText":"Classroom_contentText__bVgFa"};